import { Check, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import Container from "../ui/Container";

const About = () => {
  const features = [
    "Инновационные технические решения",
    "Профессиональная команда разработчиков",
    "Индивидуальный подход к каждому клиенту",
    "Опыт работы с крупными ритейлерами",
    "Поддержка 24/7",
    "Гибкая методология разработки"
  ];

  return (
    <section className="py-20 bg-secondary relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 -z-10">
        <div className="absolute right-0 top-1/4 w-1/3 h-1/3 bg-primary/5 rounded-full blur-3xl"></div>
        <div className="absolute left-0 bottom-1/4 w-1/4 h-1/4 bg-accent/5 rounded-full blur-3xl"></div>
      </div>

      <Container>
        <div className="flex flex-col lg:flex-row lg:items-center lg:space-x-16">
          <div className="lg:w-6/12 mb-10 lg:mb-0">
            <div className="relative">
              <div className="h-auto max-w-md mx-auto lg:mx-0 rounded-2xl overflow-hidden glass p-6 shadow-lg">
                <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1572021335469-31706a17aaef?q=80&w=2070')] bg-cover bg-center opacity-10 rounded-2xl"></div>
                <div className="relative h-full flex flex-col justify-center items-center space-y-6">
                  <div className="w-20 h-20 bg-primary/20 rounded-full flex items-center justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-primary">
                      <rect width="18" height="10" x="3" y="11" rx="2"></rect>
                      <circle cx="12" cy="5" r="2"></circle>
                      <path d="M12 7v4"></path>
                      <line x1="8" x2="8" y1="16" y2="16"></line>
                      <line x1="16" x2="16" y1="16" y2="16"></line>
                    </svg>
                  </div>
                  <div className="text-center space-y-3">
                    <div className="tag mx-auto">7+ лет на рынке</div>
                    <h3 className="text-2xl font-semibold">Цифровая трансформация бизнеса</h3>
                    <p className="text-muted-foreground">Мы создаем технологические решения, которые помогают компаниям развиваться в цифровой эпохе.</p>
                  </div>
                  <div className="grid grid-cols-3 gap-3 w-full">
                    <div className="bg-white/10 rounded-lg p-3 text-center">
                      <div className="text-2xl font-bold text-primary">50+</div>
                      <div className="text-xs text-muted-foreground">Проектов</div>
                    </div>
                    <div className="bg-white/10 rounded-lg p-3 text-center">
                      <div className="text-2xl font-bold text-primary">30+</div>
                      <div className="text-xs text-muted-foreground">Клиентов</div>
                    </div>
                    <div className="bg-white/10 rounded-lg p-3 text-center">
                      <div className="text-2xl font-bold text-primary">20+</div>
                      <div className="text-xs text-muted-foreground">Экспертов</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="absolute -z-10 -left-5 -bottom-5 w-32 h-32 bg-accent/10 rounded-full blur-xl animate-float" style={{ animationDelay: "1s" }}></div>
              <div className="absolute -z-10 -right-5 -top-5 w-24 h-24 bg-primary/10 rounded-full blur-xl animate-float" style={{ animationDelay: "2s" }}></div>
            </div>
          </div>
          <div className="lg:w-6/12">
            <div className="tag mb-4">О компании</div>
            <h2 className="heading text-3xl md:text-4xl font-bold mb-6">
              Мы помогаем бизнесу создавать современные <span className="text-gradient">цифровые продукты</span>
            </h2>
            <p className="text-muted-foreground text-lg mb-6">
              StackAdvance - компания по разработке программного обеспечения, специализирующаяся на создании инновационных решений для ритейла, электронной коммерции и логистики. Мы помогаем бизнесу оптимизировать процессы, улучшать пользовательский опыт и достигать новых высот.
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-8">
              {features.map((feature, index) => (
                <div key={index} className="flex items-start">
                  <div className="mr-3 mt-1">
                    <Check className="h-5 w-5 text-primary" />
                  </div>
                  <p className="text-foreground/80">{feature}</p>
                </div>
              ))}
            </div>
            <Link to="/about" className="button-primary">
              Узнать больше о нас
              <ArrowRight className="ml-2 h-4 w-4" />
            </Link>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default About;
